<template>
    <div>
        <label :class="['label',  {'label--required': required}]" :for="name">
            <slot></slot>
        </label>
        <textarea
            :name="name"
            :id="name"
            :value="value"
            :rows="rows"
            :placeholder="placeholder"
            :class="['textarea', {'textarea--error': computedError}]"
            @input="$emit('input', $event.target.value)"
        ></textarea>
        <span class="invalid-feedback" v-if="computedError">
            <strong>{{ computedError }}</strong>
        </span>
    </div>
</template>

<script>
    export default {
        model: {
            prop: 'value',
            event: 'input'
        },
        props: [
            'name',
            'error',
            'value',
            'required',
            'rows',
            'placeholder'
        ],
        computed: {
            computedError() {
                return this.error || this.errors(this.name);
            }
        },
    }
</script>
